/**
 * Zustand-Sortierung — die Watchlist-Rangfolge ohne Score (14.08.2026).
 *
 * ANLASS (Stufe 1 der Score-Entkopplung)
 * Ronni: „Dann kommt dieser ganze Scoring-Kram weg." Der Score hatte in der
 * Oberfläche genau eine Rolle: sortieren. Diese Rolle übernimmt jetzt das,
 * dem dieses Projekt vertraut — die Zustandsmaschine.
 *
 * DIE RANGFOLGE IST KEIN NEUER SCORE. Sie behauptet keine Qualität, sondern
 * ordnet nach NÄHE ZUR HANDLUNG:
 *
 *   1. Zone offen         — die Regel sagt: hier gibt es etwas zu tun
 *   2. Boden reift        — Beobachtung mit Trigger-Preis
 *   3. kein Setup         — nichts zu tun
 *   4. Daten unzureichend — erst die Daten klären
 *   5. noch unbekannt     — Zeile rechnet oder hat keinen Zustand
 *
 * Innerhalb einer Gruppe zählt der BEDINGUNGS-FORTSCHRITT: „es fehlt noch
 * eine Bedingung" steht über „es fehlen noch vier" (`gruende` der
 * Zustandsmaschine — das ist Zählen, keine Note). Offene Zonen mit
 * Blockade (nicht `tradeable`) stehen hinter den freien: Die Blockade ist
 * eine Sperre, keine Meinung.
 *
 * ADR 0001 bleibt unberührt: Sortieren ist Anzeige. `tradeable` entscheidet
 * Kaufwege, nie diese Funktion.
 */
import type { SetupState } from '@/lib/v6/setup-state';

export interface ZustandZeile {
  state: SetupState | null;
  isLoading: boolean;
}

/** Kleiner = weiter oben. Stabil auch für rechnende/unbekannte Zeilen. */
export function zustandSortValue(z: ZustandZeile | undefined): number {
  if (!z || z.isLoading || z.state === null) return 5_000_000;
  const s = z.state;
  const rang =
    s.zustand === 'zone_offen'
      ? 1
      : s.zustand === 'boden_reift'
        ? 2
        : s.zustand === 'daten_unzureichend'
          ? 4
          : 3;
  // Blockierte offene Zonen hinter die freien — die Sperre ist real.
  const blockade = s.zustand === 'zone_offen' && !s.tradeable ? 500 : 0;
  const fehlend = Math.min(s.gruende.length, 49);
  return rang * 1_000_000 + blockade * 1_000 + fehlend * 10;
}
